import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { FileText } from 'lucide-react';

const Terms = () => {
  const sections = [
    { title: '1. 服务说明', content: '西蒙的猫旅行日记提供AI智能旅行规划服务，包括但不限于行程生成、旅行日记、打卡相册等功能。我们保留随时修改或终止服务的权利。' },
    { title: '2. 用户责任', content: '您需对自己的账号安全负责，不得将账号转让给他人。您发布的内容应遵守法律法规，不得包含违法、侵权、虚假等信息。' },
    { title: '3. 知识产权', content: '本平台的所有内容（包括但不限于文字、图片、代码、设计）归我们所有。您生成的行程数据归您个人所有，但您授权我们在匿名化后用于改进服务。' },
    { title: '4. 免责声明', content: 'AI生成的行程仅供参考，实际旅行中可能因天气、交通、景区政策等因素产生变化。我们不对因使用本服务导致的任何损失承担责任。' },
    { title: '5. 付费服务', content: '部分高级功能可能需要付费使用。我们会在服务页面明确标注收费项目，您可自主选择是否购买。' },
    { title: '6. 账号终止', content: '如您违反服务条款，我们有权暂停或终止您的账号。账号终止后，相关数据将被删除且无法恢复。' },
    { title: '7. 争议解决', content: '因使用本服务产生的争议，双方应友好协商解决。协商不成的，可向我们所在地人民法院提起诉讼。' },
    { title: '8. 条款变更', content: '我们保留随时修改本服务条款的权利。重大变更时会提前通知用户。继续使用服务即表示您同意变更后的条款。' },
  ];

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white mb-4">
            <FileText className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-4xl font-bold text-text-primary mb-4 tracking-tight">服务条款</h1>
          <p className="text-sm text-text-secondary">生效日期：2024年1月1日</p>
        </div>

        <Card className="border-0 shadow-card rounded-card bg-white">
          <CardContent className="p-8 space-y-6">
            <p className="text-text-primary leading-relaxed">欢迎使用西蒙的猫旅行日记。在使用我们的服务前，请仔细阅读以下服务条款。使用本服务即表示您同意遵守这些条款。</p>
            {sections.map((section, idx) => (
              <div key={idx}>
                <h2 className="text-lg font-semibold text-text-primary mb-3">{section.title}</h2>
                <p className="text-text-secondary leading-relaxed">{section.content}</p>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Terms;
